/**
 * Constants and configuration values for the composer
 */

export const TIER_OPTIONS = [
  { value: 'budget', label: 'Budget (Economy)' },
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'loudest', label: 'Loudest!' }
];

export const TEMPLATE_OPTIONS = [
  { value: 'dynamic', label: 'AI Motion' },
  { value: 'animated', label: 'AI Animated' },
  { value: 'static', label: 'Static Slideshow' }
];

export const DEFAULT_VIDEO_SETTINGS = {
  aspectRatio: '9:16',
  durationSec: 10,
  tier: 'loudest',
  template: 'animated',
  tailPadSec: 0.25,
  voFadeOutSec: 0,
  voiceOffsetMs: 500
};

export const ASSET_TYPES = {
  IMAGE: 'image',
  AUDIO: 'audio',
  VIDEO: 'video',
  MUSIC: 'music'
};

export const PREVIEW_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed'
};
